import React, { useState, useEffect } from 'react';

import GenericInputContainer from '../shared/GenericInputContainer';
import DisplayAreaText from './DisplayAreaText';
import EditTextArea from './EditTextArea';

const TextAreaInputContainer = ({ initialItem, initialValue: onPageLoadValue, syncChanges, isEditing, setIsEditing, isHovered, urlLink, cancelMessage }) => {
    const [value, setValue] = useState(onPageLoadValue ? onPageLoadValue : '');
    const [initialValue, setInitialValue] = useState(onPageLoadValue ? onPageLoadValue : '');

    useEffect(() => {
        setValue(onPageLoadValue ? onPageLoadValue : '');
        setInitialValue(onPageLoadValue ? onPageLoadValue : '');
    }, [onPageLoadValue]);

    const isFieldNull = !value || !value.length;

    const valueHasntChanged = () => {
        return value === initialValue;
    };

    const handleSave = async () => {
        const syncValue = value === '' ? null : value;
        const response = await syncChanges(syncValue, initialItem);
        if (response.success) {
            setInitialValue(value);
        }
        return response;
    };

    const handleCancel = () => {
        setValue(initialValue);
    };

    return (
        <GenericInputContainer {...{ isEditing, setIsEditing, isHovered, isFieldNull, handleSave, handleCancel, valueHasntChanged, cancelMessage, saveOnEnter: false }}>
            <DisplayAreaText {...{ value, urlLink }} />
            <EditTextArea {...{ value, setValue }} />
        </GenericInputContainer>
    );
};

export default TextAreaInputContainer;
